import {
  createStyles,
  Grid,
  Paper,
  Typography,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { downloadRainHistoryCsv, importRainHistoryCsv } from "redux/operations";
import type { Retreat } from "shared/types";
import RainHistoryImportForm from "./rainHistoryImportForm";

type RainHistoryPageProps = {
  downloadRainHistory: (
    ...params: Parameters<typeof downloadRainHistoryCsv>
  ) => Promise<void>;
  importRainHistory: (
    ...params: Parameters<typeof importRainHistoryCsv>
  ) => Promise<void>;
  retreats: Retreat[];
} & WithStyles<typeof styles>;

function RainHistoryPage({
  classes,
  downloadRainHistory,
  importRainHistory,
  retreats,
}: RainHistoryPageProps) {
  const { t } = useTranslations();

  return (
    <Paper className={classes.root} square={true}>
      <Grid item sm={12} xs={12} className={classes.grid}>
        <Typography className={classes.header} gutterBottom={true}>
          {t("locales:rain-history")}
        </Typography>

        <RainHistoryImportForm
          downloadRainHistory={downloadRainHistory}
          importRainHistory={importRainHistory}
          retreats={retreats}
        />
      </Grid>
    </Paper>
  );
}

const styles = () =>
  createStyles({
    root: {
      bottom: 0,
      height: "100%",
      minHeight: "calc(100vh - 90px)",
      overflowX: "auto",
      padding: "46px",
      top: "17%",
      width: "100%",
      zIndex: -1,
    },
    grid: {
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      gap: "24px",
      height: "100%",
      width: "100%",
    },
    header: {
      fontSize: "20px",
      fontWeight: "bold",
      fontStyle: "medium",
      fontStretch: "medium",
      lineHeight: "medium",
      letterSpacing: "medium",
      color: "#333333",
      marginTop: "40px",
    },
  });

export default withStyles(styles)(RainHistoryPage);
